import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BurgerMenuComponent } from './burger-menu';
import { TranslateModule } from '@ngx-translate/core';
import { EditWorkFileNameModalComponent } from './rename-workFileName-modal';
import { ReactiveFormsModule } from '@angular/forms';
import { PopoverService } from './popover/services/popover.service';
import { ExportPopoverComponent } from './popover/components/export-popover.component';
import { HeaderComponent } from './header';
import { BurgerMenuState } from './burger-menu/services';
import { SortingComponent } from './sorting/sorting.component';
import { SharedModule } from '@shared';
import { SortingButtonComponent } from './sorting/sorting-button';
import { CopyinCheckinCheckoutComponent } from './copyin-checkin-checkout/copyin-checkin-checkout.component';
import {
	ConnectionOptionsComponent,
	DataAndStructureTransferOutStrategy,
	ItemPickerFactoryService,
	StructureTransferOutStrategy
} from './connection-options';
import { CSVFileExporterService, ExcelFileExporterService, FileExporterService, FileWriterService } from '@domain/file-exporter';
import { PdfFileExporterService } from 'src/domain/file-exporter/services/pdf-file-exporter.service';

@NgModule({
	declarations: [
		BurgerMenuComponent,
		EditWorkFileNameModalComponent,
		ExportPopoverComponent,
		HeaderComponent,
		SortingComponent,
		CopyinCheckinCheckoutComponent,
		ConnectionOptionsComponent,
		SortingButtonComponent
	],
	exports: [
		BurgerMenuComponent,
		EditWorkFileNameModalComponent,
		HeaderComponent,
		SortingButtonComponent,
		ConnectionOptionsComponent,
		CopyinCheckinCheckoutComponent,
		SortingComponent
	],
	imports: [CommonModule, TranslateModule, ReactiveFormsModule, SharedModule],
	providers: [
		PopoverService,
		BurgerMenuState,
		ItemPickerFactoryService,
		StructureTransferOutStrategy,
		FileExporterService,
		ExcelFileExporterService,
		CSVFileExporterService,
		PdfFileExporterService,
		FileWriterService,
		DataAndStructureTransferOutStrategy,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SmartComponentsModule {}
